import { ACCESS_LEVEL_VIEW, ACCESS_LEVEL_PURCHASE } from "../../../constants";

const getTapingKey = (customerAccess, showCountdown) => {
  if (customerAccess === ACCESS_LEVEL_PURCHASE) {
    return showCountdown
      ? "early_access_taping_early_access_countdown"
      : "early_access_taping_early_access_end_date";
  }

  if (customerAccess === ACCESS_LEVEL_VIEW) {
    return showCountdown
      ? "early_access_taping_coming_soon_countdown"
      : "early_access_taping_coming_soon_end_date";
  }

  return null;
};

export default getTapingKey;
